export default __webpack_public_path__ + "static/media/30.c7161de6.jpeg";